import { Component, computed, effect, input, output, signal, ChangeDetectionStrategy } from '@angular/core'
import { MONTHS_LIST } from '@lla-platform/core/core-util'

@Component({
  selector: 'lla-month-selector',
  templateUrl: './month-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MonthSelectorComponent {
  selectedMonth = input(new Date().getFullYear() * 100 + (new Date().getMonth() + 1)) // YYYYMM
  includeFuture = input(false)

  monthSelected = output<number>()

  viewYear = signal(new Date().getFullYear())
  months = MONTHS_LIST
  currentYear = new Date().getFullYear()

  selectedMonthIndex = computed(() => (this.selectedMonth() % 100) - 1)
  selectedYear = computed(() => Math.floor(this.selectedMonth() / 100))

  disabledMonths = computed(() => {
    if (this.includeFuture()) return new Array(12).fill(false)
    const currentMonth = new Date().getMonth() + 1
    const year = this.viewYear()
    return Array.from(
      { length: 12 },
      (_, i) => year > this.currentYear || (year === this.currentYear && i + 1 > currentMonth)
    )
  })

  constructor() {
    effect(() => {
      const month = this.selectedMonth()
      if (month) {
        this.viewYear.set(Math.floor(month / 100))
      }
    })
  }

  navigateYear(delta: number) {
    const newYear = this.viewYear() + delta
    if (!this.includeFuture() && newYear > this.currentYear) return
    this.viewYear.set(newYear)
  }

  selectMonth(monthIndex: number) {
    if (this.disabledMonths()[monthIndex]) return
    const value = this.viewYear() * 100 + (monthIndex + 1)
    this.monthSelected.emit(value)
  }

  resetViewYear() {
    this.viewYear.set(this.selectedYear())
  }
}
